import palette from './palette';
import typography from './typography';
import overrides from './overrides';

const OverrideThemeProps = {
  palette,
  typography,
  overrides,
};

export default OverrideThemeProps;



// WEBPACK FOOTER //
// ./src/components/OverrideTheme/config/index.js